import Service from "../AuthService";

const data = {
    // Number Box
    getNumberBox() {
        return Service.get(`/api/frontend/overview/number`);
    },
    getNumberBoxDataStats() {
        return Service.get(`/api/statistic/number-industry`);
    },
    updateNumberBox(id, data) {
        return Service.put(`/api/number-box/${id}`, {
            topic_id: data.topic_id,
            position: id
        })
    },
    updateNumberBoxDataStats(id, data) {
        return Service.put(`/api/number-box-industry/${id}`, {
            topic_id: data.topic_id,
            position: id
        })
    },

    // Title
    getAllTopic() {
        return Service.get(`/api/topic/all`);
    },

    getAllTopicPaginate(data) {
        let page = data.page ? data.page : 1;
        return Service.get(`/api/topic?page=${page}`, { headers: { Authorization: `Bearer ${data.token}` } });
    },

    searchTopic(data) {
        return Service.post(`api/topic/search`, {
            keyword: data.keyword
        }, {
            headers: { Authorization: `Bearer ${data.token}` }
        });
    },

    getTopic(data) {
        return Service.get(`/api/topic/${data.id}`, { headers: { Authorization: `Bearer ${data.token}` } });
    },

    createTopic(data) {
        return Service.post(`/api/topic`, {
            name_th: data.name_th,
            name_en: data.name_en
        }, {
            headers: { Authorization: `Bearer ${data.token}` }
        });
    },

    editTopic(data) {
        return Service.put(`/api/topic/${data.id}`, {
            name_th: data.name_th,
            name_en: data.name_en
        }, {
            headers: { Authorization: `Bearer ${data.token}` }
        });
    },

    deleteTopic(data) {
        return Service.delete(`/api/topic/${data.id}`, { headers: { Authorization: `Bearer ${data.token}` } });
    },


    // Imported
    getAllImported(data) {
        return Service.get(`/api/data/all`, { headers: { Authorization: `Bearer ${data.token}` } });
    },

    getAllImportedPaginate(data) {
        let page = data.page ? data.page : 1;
        return Service.get(`/api/import/data?page=${page}`, { headers: { Authorization: `Bearer ${data.token}` } });
    },

    searchImport(data) {
        return Service.post(`api/data/search`, {
            keyword: data.keyword ? data.keyword : null,
            year: data.year !== 'All' ? data.year : null
        }, {
            headers: { Authorization: `Bearer ${data.token}` }
        });
    },

    getImported(data) {
        return Service.get(`/api/import/data/${data.id}`, { headers: { Authorization: `Bearer ${data.token}` } });
    },

    createImported(data) {
        return Service.post(`/api/import/data`, {
            topic_id: data.topic_id,
            index_id: data.index_id,
            year_data: data.year_data,
            file_path: data.file_path,
            display_status: data.display_status,
            name: data.name
        }, {
            headers: { Authorization: `Bearer ${data.token}` }
        });
    },

    editImported(data) {
        return Service.put(`/api/import/data/${data.id}`, {
            topic_id: data.topic_id,
            index_id: data.index_id,
            year_data: data.year_data,
            file_path: data.file_path,
            display_status: data.display_status,
            name: data.name
        }, {
            headers: { Authorization: `Bearer ${data.token}` }
        });
    },

    deleteImported(data) {
        return Service.delete(`/api/import/data/${data.id}`, { headers: { Authorization: `Bearer ${data.token}` } });
    },


    // Unit
    getAllUnit(data) {
        return Service.get(`/api/unit/all`, { headers: { Authorization: `Bearer ${data.token}` } });
    },

    getAllUnitPaginate(data) {
        let page = data.page ? data.page : 1;
        return Service.get(`/api/unit?page=${page}`, { headers: { Authorization: `Bearer ${data.token}` } });
    },

    getUnit(data) {
        return Service.get(`/api/unit/${data.id}`, { headers: { Authorization: `Bearer ${data.token}` } });
    },

    createUnit(data) {
        return Service.post(`/api/unit`, {
            name_th: data.name_th,
            name_en: data.name_en
        }, {
            headers: { Authorization: `Bearer ${data.token}` }
        });
    },

    editUnit(data) {
        return Service.put(`/api/unit/${data.id}`, {
            name_th: data.name_th,
            name_en: data.name_en
        }, {
            headers: { Authorization: `Bearer ${data.token}` }
        });
    },

    deleteUnit(data) {
        return Service.delete(`/api/unit/${data.id}`, { headers: { Authorization: `Bearer ${data.token}` } });
    },


    // Tag
    getAllTag(data) {
        return Service.get(`/api/tag/all`, { headers: { Authorization: `Bearer ${data.token}` } });
    },

    getAllTagPaginate(data) {
        let page = data.page ? data.page : 1;
        return Service.get(`/api/tag?page=${page}`, { headers: { Authorization: `Bearer ${data.token}` } });
    },

    getTag(data) {
        return Service.get(`/api/tag/${data.id}`, { headers: { Authorization: `Bearer ${data.token}` } });
    },

    createTag(data) {
        return Service.post(`/api/tag`, {
            name: data.name
        }, {
            headers: { Authorization: `Bearer ${data.token}` }
        });
    },

    editTag(data) {
        return Service.put(`/api/tag/${data.id}`, {
            name: data.name
        }, {
            headers: { Authorization: `Bearer ${data.token}` }
        });
    },

    deleteTag(data) {
        return Service.delete(`/api/tag/${data.id}`, { headers: { Authorization: `Bearer ${data.token}` } });
    },

    //main menu
    index(data) {
        return Service.get(`/api/main-menu?page=${data.page}`, { headers: { Authorization: `Bearer ${data.token}` } })
    },
    show(data) {
        return Service.get(`/api/main-menu/${data.id}`)
    },
    update(data) {
        return Service.put(`/api/main-menu/${data.id}`, {
            name_th: data.name_th,
            name_en: data.name_en,
            src_url: data.src_url,
            status: data.status,
        },{
            headers: { Authorization: `Bearer ${data.token}` }
        })
    }

};

export default data;
